import {
  postRequest,
  getRequest,
  postRequestWithFiles,
} from "../system/server-call";
import {
  AUTH,
  FORGOTPASSWORD,
  RESETPASSWORD,
  USER,
  globalConstants,
} from "../constants";
import { clearUserData } from "../system";
import responseHandler from "../system/server-response-handler";

async function verifyEmail(emailData) {
  const email = { email: emailData };
  return postRequest(
    `/${globalConstants.VERSION}/${AUTH}/${FORGOTPASSWORD}`,
    email,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function login(userData) {
  return postRequest(
    `/${globalConstants.VERSION}/${AUTH}`,
    userData,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getNewUserPayload(token) {
  return postRequest(
    `/${globalConstants.VERSION}/${AUTH}/Refresh?token=${token}`,
    null,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function resetPassword(resetData) {
  return postRequest(
    `/${globalConstants.VERSION}/${AUTH}/${RESETPASSWORD}`,
    resetData,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function registerUser(userData) {
  const formData = new FormData();
  for (const key in userData) {
    if (key === "documents") {
      for (const innerKey in userData.documents) {
        formData.append(key, userData[key][innerKey]);
      }
    } else {
      formData.append(key, userData[key]);
    }
  }
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/${USER}`,
    formData,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function becomeVerifiedUser(VerfiedDocsData) {
  const formData = new FormData();
  for (const key in VerfiedDocsData) {
    if (key === "documents") {
      for (const innerKey in VerfiedDocsData.documents) {
        formData.append(key, VerfiedDocsData[key][innerKey]);
      }
    } else {
      formData.append(key, VerfiedDocsData[key]);
    }
  }

  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Documents/User`,
    formData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function fetchCountries() {
  return getRequest(`/${globalConstants.VERSION}/Country/all`, false).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function fetchCities(countryId) {
  return getRequest(
    `/${globalConstants.VERSION}/Country/cities/${countryId}`,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function registrationStatus(userDetail) {
  return postRequest(
    `/${globalConstants.VERSION}/Auth/VerifyEmail?userId=${
      userDetail.userId
    }&token=${userDetail.token}&code=${userDetail.code.split('"')[0]}`,
    null,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function resendEmail(userId) {
  return postRequest(
    `/${globalConstants.VERSION}/Auth/ResendVerifyEmailToken/${userId}`,
    null,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function changePassword(data) {
  return postRequest(
    `/${globalConstants.VERSION}/${AUTH}/UpdatePassword`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const updateUserDocuments = (data) => {
  const formData = new FormData();
  for (const key in data) {
    if (key === "documents") {
      for (const innerKey in data.documents) {
        formData.append(key, data[key][innerKey]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }

  return postRequestWithFiles(
    `/${globalConstants.VERSION}/User/update/documents`,
    formData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const authService = {
  verifyEmail,
  login,
  resetPassword,
  registerUser,
  becomeVerifiedUser,
  fetchCountries,
  fetchCities,
  registrationStatus,
  resendEmail,
  changePassword,
  updateUserDocuments,
  getNewUserPayload,
};
